export const localStorage = {
  get<Type>(reference: string): Type | undefined {
    try {
      const rawValue = window.localStorage.getItem(reference);
      if (rawValue) {
        return JSON.parse(rawValue);
      }
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  set(reference: string, payload: any) {
    try {
      window.localStorage.setItem(reference, JSON.stringify(payload));
    } catch (e) {
      console.error(e);
      if (!(e instanceof DOMException)) {
        throw e;
      }
    }
  },

  remove(reference: string) {
    try {
      window.localStorage.removeItem(reference);
    } catch (e) {
      console.error(e);
    }
  },

  clear() {
    try {
      window.localStorage.clear();
    } catch (e) {
      console.error(e);
    }
  },
};
